function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const dirWebApp = process.env.REACT_APP_DIR_PRO

const CardsAlumno = (props) => {

    const handlelink = (pagina) => {
        window.location.replace(dirWebApp + pagina)
    }

    return (
        <li key={props.id} className={classNames(props.color ? ' border border-secundario shadow-sm shadow-secundario' : ' border border-secundarioMira shadow-md shadow-secundarioMira', 'overflow-hidden rounded-xl')} >
            <div className={classNames(props.color ? 'bg-secundarioMira' : 'bg-secundarioMira', 'flex items-center gap-x-4 border-b border-gray-900/5 p-4')}>
                {props.imageUrl &&
                    <props.imageUrl
                        className={classNames(props.color ? 'text-white' : 'text-secundario', 'h-9 w-9')}
                        aria-hidden="true"
                    />
                }
                <div className={classNames(props.color ? 'text-secundario' : 'text-white', 'text-lg font-semibold leading-6')}>{props.name}</div>
            </div>
            <dl className={classNames(props.color ? 'bg-primarioMira' : 'bg-primarioMira', '-my-3 divide-y divide-white px-6 py-4 text-sm leading-6')}>
                <div className="flex justify-between gap-x-4 py-3">
                    <dt className={classNames(props.color ? 'text-grisMira' : 'text-grisMira', 'font-semibold text-base')}>{props.descrip}</dt>
                    <dd className={classNames(props.color && props.detail !== '' && props.detail !== null && props.detail !== undefined ? 'text-grisMira bg-red-400 rounded-full inline-flex px-1 py-1 w-full lg:w-1/4 place-content-center' : null, 'text-white font-semibold text-base')}>{props.detail}</dd>
                </div>
                <div className={classNames('flex justify-between gap-x-4 py-3')}>
                    <dt className={classNames(props.color ? 'text-grisMira' : 'text-grisMira', 'font-semibold text-base')}>{props.descrip2}</dt>
                    <div className={classNames(props.color && props.detail2 !== '' && props.detail2 !== null && props.detail2 !== undefined ? 'text-grisMira bg-red-400 rounded-full inline-flex px-1 py-1 w-full lg:w-1/4 place-content-center' : null, 'text-white font-semibold text-base')}>{props.detail2}</div>
                </div>
            </dl>

            {props.vermas === 1
                ? props.click
                    ? <button onClick={() => props.click()} className={classNames(props.color ? 'bg-azulBrillanteMira' : 'hover:bg-azulBrillanteMira', 'w-full')}>
                        <div className={classNames(props.color ? 'bg-secundarioMira' : 'bg-secundarioMira', props.color ? 'hover:bg-azulBrillanteMira' : 'hover:bg-azulBrillanteMira', 'py-2')}>
                            <div className="text-sm text-center">
                                <p className="text-white text-base font-semibold hover:underline hover:text-white">{props.tvermas ? props.tvermas : 'Ver más'}</p>
                            </div>
                        </div>
                    </button>
                    : <button onClick={() => handlelink(props.path)} className={classNames(props.color ? 'bg-azulBrillanteMira' : 'hover:bg-azulBrillanteMira', 'w-full')}>
                        <div className={classNames(props.color ? 'bg-secundarioMira' : 'bg-secundarioMira', props.color ? 'hover:bg-azulBrillanteMira' : 'hover:bg-azulBrillanteMira', 'py-2')}>
                            <div className="text-sm text-center">
                                <p className="text-white text-base font-semibold hover:underline hover:text-white">{props.tvermas ? props.tvermas : 'Ver más'}</p>
                            </div>
                        </div>
                    </button>
                : <div className={classNames(props.color ? 'bg-secundarioMira' : 'bg-secundarioMira', 'py-5')}>
                </div>
            }

        </li >
    )
}

export default CardsAlumno